const getPixelRatio = () => window.devicePixelRatio || 1;

/**
 * Reports the CSS size of `element` and the device pixel ratio whenever
 * either changes: container resize, page zoom, moving the window to a screen
 * with another density.
 *
 * @param {HTMLElement} element
 * @param {(size: { width: number, height: number, pixelRatio: number }) => void} onResize
 * @returns {() => void} stops observing
 */
export const observeSize = (element, onResize) => {
  let cssSize = null;
  let ratioQuery = null;

  const notify = () => {
    if (cssSize) onResize({ ...cssSize, pixelRatio: getPixelRatio() });
  };

  const handleRatioChange = () => {
    // The query matches only the old ratio, so a new one is needed each time
    ratioQuery.removeEventListener("change", handleRatioChange);
    ratioQuery = window.matchMedia(`(resolution: ${getPixelRatio()}dppx)`);
    ratioQuery.addEventListener("change", handleRatioChange);
    notify();
  };

  ratioQuery = window.matchMedia(`(resolution: ${getPixelRatio()}dppx)`);
  ratioQuery.addEventListener("change", handleRatioChange);

  const resizeObserver = new ResizeObserver(([entry]) => {
    const { width, height } = entry.contentRect;

    cssSize = { width, height };
    notify();
  });

  resizeObserver.observe(element);

  return () => {
    resizeObserver.disconnect();
    ratioQuery.removeEventListener("change", handleRatioChange);
  };
};
